import React from 'react';

import { SimpleHeaderProps } from './interfaces';
import Main from './Main';

const Header: React.FC<SimpleHeaderProps> = ({
  title,
  pictureLogo,
  isMobile,
  buttons,
  dashInfo,
}) => {
  return (
    <Main
      isMobile={isMobile}
      pictureLogo={pictureLogo}
      title={title}
      buttons={buttons}
      dashInfo={dashInfo}
    />
  );
};

export default Header;
